var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("image-rotator", {
        ref: "imagerotater",
        attrs: {
          images: _vm.images,
          videos: _vm.videos,
          showHeliviewBtn: _vm.videos && _vm.videos.length ? true : false
        },
        on: {
          show: function(image) {
            return (_vm.shownImage = image)
          },
          heliviewclick: _vm.showHeliSlides
        }
      }),
      _vm._v(" "),
      _vm.shownImage !== null
        ? _c(
            "modal",
            {
              staticClass: "image-modal",
              attrs: {
                "no-scroll": true,
                "close-on-click": true,
                "is-open": _vm.openModal
              },
              on: {
                close: function($event) {
                  _vm.shownImage = null
                }
              }
            },
            [
              _c("image-rotator", {
                attrs: {
                  images: _vm.images,
                  videos: _vm.videos,
                  "start-image": _vm.shownImage,
                  "pagination-enabled": true,
                  thumbnail: false,
                  enableKeys: true
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c92e658", { render: render, staticRenderFns: staticRenderFns })
  }
}